var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{attrs:{"clearable":"","placeholder":"请选择结论"},model:{value:(_vm.jg),callback:function ($$v) {_vm.jg=$$v},expression:"jg"}},[_c('el-option',{attrs:{"label":"符合要求","value":"符合要求"}}),_c('el-option',{attrs:{"label":"不符合要求","value":"不符合要求"}}),_c('el-option',{attrs:{"label":"无此项","value":"无此项"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }